
















































import {Component} from 'vue-property-decorator'
import UserMixin from "@/lib/mixins/UserMixin";
import {mixins} from "vue-class-component";
import BankAccount from "@/lib/models/BankAccount";
import EditModal from "@/components/account/editModal.vue";

@Component({
    components: {
        EditModal
    }
})
export default class AccountView extends mixins(UserMixin) {
    private $firebase: any;
    private loaded: boolean = false;
    private collection: firebase.database.Reference | null = null;

    public accounts: BankAccount[] = [];
    public accountToEdit: BankAccount | null = null;

    created() {
        this.collection = this.$firebase.database().ref('account/' + this.loggedUser.uid);
        if (this.collection) {
            this.collection.on('value', (snapshot: any) => {
                if (!this.loaded) this.loaded = true;
                if (snapshot.val() !== null) {
                    this.accounts = Object.keys(snapshot.val()).map((key: string) => {
                        return (new BankAccount()).fromObject(snapshot.val()[key], {}, key) as BankAccount;
                    });
                }
            });
        }
    }

    createAccount() {
        if (this.collection !== null) {
            const newAccount = (new BankAccount()).fromObject({name: "New Account"});
            this.collection.push().set(newAccount)
        }
    }

    private toggleEditModal(account: BankAccount) {
        this.accountToEdit = account;
        if (this.$refs.editModalRef) {
            (this.$refs.editModalRef as EditModal).toggle();
        }
    }
}
